import {
  listBlogs,
  createBlog,
  updateBlog,
  deleteBlog,
  getBlogById,
} from "../../services/blog";

const state = {
  blogList: [] as any[],
  blogData: {} as any,
};

const mutations = {
  setBlogList(state: any, data: any) {
    state.blogList = data;
  },
  setBlogData(state: any, data: any) {
    state.blogData = data;
  },
};

const actions = {
  async createBlog(_context: any, payload: any) {
    try {
      const data = await createBlog(payload);
      return data;
    } catch (error) {
      throw error;
    }
  },

  async updateBlog(_context: any, payload: any) {
    try {
      const data = await updateBlog(payload.id, payload.data);
      return data;
    } catch (error) {
      throw error;
    }
  },

  async fetchBlogsList({ commit }: any) {
    try {
      const data = await listBlogs();
      commit("setBlogList", data.response || data.data || []);
      return data;
    } catch (error) {
      throw error;
    }
  },

  async fetchBlogById({ commit }: any, id: string) {
    try {
      const data = await getBlogById(id);
      commit("setBlogData", data.response || data.data || {});
      return data;
    } catch (error) {
      throw error;
    }
  },

  async deleteBlog(_context: any, id: string) {
    try {
      const data = await deleteBlog(id);
      return data;
    } catch (error) {
      throw error;
    }
  },

  async sendBlogData({ commit }: any, payload: any) {
    try {
      commit("setBlogData", payload);
      return payload;
    } catch (error) {
      throw error;
    }
  },
};

const getters = {
  GetBlogList: (state: any) => state.blogList,
  GetBlogData: (state: any) => state.blogData,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
